var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7379 12.5717C33.5267 13.3934 33.5001 14.699 32.6783 15.4879L24.0846 23.7379C23.2865 24.504 22.026 24.504 21.2279 23.7379L16.0717 18.7879C15.2499 17.999 15.2233 16.6934 16.0121 15.8717C16.801 15.0499 18.1066 15.0233 18.9283 15.8121L22.6563 19.3909L29.8217 12.5121C30.6434 11.7233 31.949 11.7499 32.7379 12.5717Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.3125 14C0.3125 6.78578 6.16078 0.9375 13.375 0.9375H40.875C43.5329 0.9375 45.6875 3.09213 45.6875 5.75V47C45.6875 49.6579 43.5329 51.8125 40.875 51.8125H10.625C4.92956 51.8125 0.3125 47.1954 0.3125 41.5V14ZM4.4375 33.2492C6.16105 31.9546 8.30344 31.1875 10.625 31.1875H41.5625V5.75C41.5625 5.3703 41.2547 5.0625 40.875 5.0625H13.375C8.43896 5.0625 4.4375 9.06396 4.4375 14V33.2492ZM4.4375 41.5C4.4375 44.9173 7.20774 47.6875 10.625 47.6875H40.875C41.2547 47.6875 41.5625 47.3797 41.5625 47V35.3125H10.625C7.20774 35.3125 4.4375 38.0827 4.4375 41.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookCheck);
export default __webpack_public_path__ + "static/media/book-check.c530eaa1d93afd921462143e58ebfe94.svg";
export { ForwardRef as ReactComponent };